import { render, staticRenderFns } from "./personNews.vue?vue&type=template&id=1bf66905&scoped=true&"
import script from "./personNews.vue?vue&type=script&lang=js&"
export * from "./personNews.vue?vue&type=script&lang=js&"
import style0 from "./personNews.vue?vue&type=style&index=0&id=1bf66905&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf66905",
  null
  
)

export default component.exports